import React, { useState } from 'react';
import Sidebar from './components/Layout/Sidebar';
import TopBar from './components/Layout/TopBar';
import Dashboard from './pages/Dashboard';
import PipelineRunner from './pages/PipelineRunner';
import EmployerConfig from './pages/EmployerConfig';
import EmployeeProfiles from './pages/EmployeeProfiles';
import WorkbookOutput from './pages/WorkbookOutput';
import ValidationFlags from './pages/ValidationFlags';
import ApiLoader from './pages/ApiLoader';
import Reconciliation from './pages/Reconciliation';
import AuditLog from './pages/AuditLog';

const PAGES = {
  dashboard: Dashboard,
  pipeline: PipelineRunner,
  employer: EmployerConfig,
  employees: EmployeeProfiles,
  workbook: WorkbookOutput,
  validation: ValidationFlags,
  loader: ApiLoader,
  reconciliation: Reconciliation,
  audit: AuditLog,
};

export default function App() {
  const [page, setPage] = useState('dashboard');
  const PageComponent = PAGES[page] || Dashboard;

  return (
    <div className="app-shell">
      <Sidebar page={page} setPage={setPage} />
      <div className="main-area">
        <TopBar page={page} />
        <PageComponent />
      </div>
    </div>
  );
}
